import { fetchDownloadUrl as fetchDownloadUrlData } from "./downloadDataServices";

export async function fetchDownloadUrl() {
    return fetchDownloadUrlData();
}

export function openDownloadUrl(url) {
    window.open(url, "_blank");
}
